import React from 'react';

const AISummaryContent = ({ summary }) => {
    const renderSummaryContent = (text) => {
        if (!text) return null;

        // Check if content is already HTML (starts with < tag)
        if (text.trim().startsWith('<')) {
            // Render HTML directly, processing citations first via the global utility
            let processedHtml = text;
            if (window.imProcessCitationsInHtml) {
                processedHtml = window.imProcessCitationsInHtml(text);
            }
            return <div dangerouslySetInnerHTML={{ __html: processedHtml }} />;
        }

        // Otherwise, parse as markdown format
        const lines = text.split('\n');
        const elements = [];
        let currentList = [];
        let inList = false;

        lines.forEach((line, index) => {
            // Check if line is a bullet point
            if (line.trim().startsWith('- ')) {
                if (!inList) {
                    inList = true;
                    currentList = [];
                }
                currentList.push(line.trim().substring(2));
            } else if (line.trim().startsWith('**') && line.trim().endsWith('**')) {
                // Bold headers
                if (inList && currentList.length > 0) {
                    elements.push(
                        <ul key={`ul-${elements.length}`}>
                            {currentList.map((item, i) => (
                                <li key={i}>{item}</li>
                            ))}
                        </ul>
                    );
                    currentList = [];
                    inList = false;
                }
                const headerText = line.trim().replace(/\*\*/g, '');
                elements.push(<strong key={`header-${index}`}>{headerText}</strong>);
            } else if (line.trim() === '') {
                // Empty line - end current list if in one
                if (inList && currentList.length > 0) {
                    elements.push(
                        <ul key={`ul-${elements.length}`}>
                            {currentList.map((item, i) => (
                                <li key={i}>{item}</li>
                            ))}
                        </ul>
                    );
                    currentList = [];
                    inList = false;
                }
                elements.push(<br key={`br-${index}`} />);
            } else {
                // Regular text
                if (inList && currentList.length > 0) {
                    elements.push(
                        <ul key={`ul-${elements.length}`}>
                            {currentList.map((item, i) => (
                                <li key={i}>{item}</li>
                            ))}
                        </ul>
                    );
                    currentList = [];
                    inList = false;
                }
                if (line.trim()) {
                    elements.push(<span key={`text-${index}`}>{line}</span>);
                }
            }
        });

        // Close any remaining list
        if (inList && currentList.length > 0) {
            elements.push(
                <ul key={`ul-${elements.length}`}>
                    {currentList.map((item, i) => (
                        <li key={i}>{item}</li>
                    ))}
                </ul>
            );
        }

        return <>{elements}</>;
    };

    return <div className="ai-summary-text">{renderSummaryContent(summary)}</div>;
};

export default AISummaryContent;
